export interface DocumentApi {
  generate: (applicationId: string) => Promise<Blob>;
}

export const DOCUMENT_API_KEY = 'documentApi';
